module.exports = __webpack_public_path__ + "img/pdf.46705b10.svg";